import { request } from '@/request/http';

export const getRouterURL = () => request({ method: 'GET', url: '/getRouters' });

export const getUser = () => request({ method: 'GET', url: '/api/getInfo' })